import { starHighlightedIcon } from '../../../styles/icons';
import {
  ActionCellRenderer,
  ActionTypes,
} from '../../../utils/custom-renderer/action-cell-renderer';
import {
  HyperlinkStaticCellRenderer,
  IGridHyperlink,
} from '../../../utils/custom-renderer/hyperlink-cell-renderer';
import { getNumericPattern } from '../../../utils/formatting';
import type { WatchlistProjectCard } from './watchlist-project-card';

export enum COLUMN_FIELDS {
  TICKER = 'TICKER',
  UNIQUE_ID = 'UNIQUE_ID',
  FIXED_PRICE = 'FIXED_PRICE',
  OFFERED_CAPACITY = 'OFFERED_CAPACITY',
  ACTIONS = 'ACTIONS',
}

export function VPPA_WATCHLIST_COLUMNS(context: WatchlistProjectCard) {
  return [
    {
      field: COLUMN_FIELDS.TICKER,
      headerName: 'Ticker',
      suppressMenu: true,
      flex: 1,
    },

    {
      field: COLUMN_FIELDS.UNIQUE_ID,
      headerName: 'Unique ID',
      suppressMenu: true,
      flex: 1,
      valueGetter: (props) => {
        return JSON.stringify({
          NAME: props.data.UNIQUE_ID,
          PROJECT_ID: props.data.PROJECT_ID,
        });
      },
      cellRenderer: HyperlinkStaticCellRenderer,
      cellRendererParams: (params) => {
        const obj = JSON.parse(params.value);
        const hyperlinkParams: IGridHyperlink = {
          value: obj.NAME,
          id: obj.PROJECT_ID,
          vppaId: params.data?.WATCHLIST_ENTITY_ID,
          iconList: [],
        };
        return hyperlinkParams;
      },
    },
    {
      field: COLUMN_FIELDS.FIXED_PRICE,
      headerName: 'Fixed Price',
      valueFormatter: (params) => getNumericPattern(params.data.FIXED_PRICE, null, '$'),
      suppressMenu: true,
      flex: 1,
    },
    {
      field: COLUMN_FIELDS.OFFERED_CAPACITY,
      headerName: 'Capacity (MW)',
      suppressMenu: true,
      flex: 1,
    },
    {
      field: COLUMN_FIELDS.ACTIONS,
      headerName: '',
      suppressMenu: true,
      width: 45,
      suppressRowClickSelection: true,
      pinned: 'right',
      cellStyle: {
        'padding-right': '7px',
        'box-shadow': '-5px 0px 15px 0px rgba(0, 0, 0, 0.2)',
      },
      cellRenderer: ActionCellRenderer,
      cellRendererParams: (params) => {
        const removeBtn = {
          name: starHighlightedIcon(),
          callback: (detail) => {
            context.switchCardsForVppaDeletion(detail);
          },
          type: ActionTypes.FAVORITE,
          actionName: 'remove-vppa-watchlist',
        };
        const actions = [removeBtn];
        const enabled = true;
        return {
          actions,
          enabled,
        };
      },
    },
  ];
}
